/**
 * @fileoverview Hook responsável por buscar os indicadores consolidados do dashboard.
 */

import { useCallback } from "react";
import api from "../../services/api";

const useDashboard = () => {

    const find = useCallback(async (params) => {
        const { data } = await api.request({
            url: `/dashboard`,
            method: 'GET',
            params
        });
        return data;
    }, []);

    // Versão enxuta pro indicador da sidebar: o backend roda só os 2 COUNTs do
    // noResponseRate em vez das 9 queries do /dashboard completo.
    const findNoResponseRate = useCallback(async () => {
        const { data } = await api.request({
            url: `/dashboard/no-response-rate`,
            method: 'GET'
        });
        return data;
    }, []);

    return {
        find,
        findNoResponseRate
    }
}

export default useDashboard;
